/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signature_ColorInputs */

const en_signature_color = /** @type {(inputs: Signature_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signature Color`)
};

const es_signature_color = /** @type {(inputs: Signature_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color distintivo`)
};

const fr_signature_color = /** @type {(inputs: Signature_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couleur signature`)
};

const de_signature_color = /** @type {(inputs: Signature_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Signaturfarbe`)
};

const ja_signature_color = /** @type {(inputs: Signature_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シグネチャーカラー (メインカラー)`)
};

const zh_signature_color = /** @type {(inputs: Signature_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标志性主色调`)
};

const ar_signature_color = /** @type {(inputs: Signature_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اللون المميز`)
};

const id_signature_color = /** @type {(inputs: Signature_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warna Khas`)
};

const it_signature_color = /** @type {(inputs: Signature_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colore Distintivo`)
};

const ru_signature_color = /** @type {(inputs: Signature_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Фирменный цвет`)
};

const pt_signature_color = /** @type {(inputs: Signature_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cor de Assinatura`)
};

const ko_signature_color = /** @type {(inputs: Signature_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`시그니처 컬러`)
};

/**
* | output |
* | --- |
* | "Signature Color" |
*
* @param {Signature_ColorInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const signature_color = /** @type {((inputs?: Signature_ColorInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signature_ColorInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signature_color(inputs)
	if (locale === "es") return es_signature_color(inputs)
	if (locale === "fr") return fr_signature_color(inputs)
	if (locale === "de") return de_signature_color(inputs)
	if (locale === "ja") return ja_signature_color(inputs)
	if (locale === "zh") return zh_signature_color(inputs)
	if (locale === "ar") return ar_signature_color(inputs)
	if (locale === "id") return id_signature_color(inputs)
	if (locale === "it") return it_signature_color(inputs)
	if (locale === "ru") return ru_signature_color(inputs)
	if (locale === "pt") return pt_signature_color(inputs)
	return ko_signature_color(inputs)
});